import React from 'react';
import BtPlusLogo from '../../assets/images/boardtrac_plus_logo.svg';
import { Route, Switch, Redirect } from 'react-router-dom';

import SignInForm from './components/SignInForm';
import ForgottenForm from './components/ForgottenForm';
import RegisterForm from './components/RegisterForm';
import PinForm from './components/PinForm';
import ForgottenConfirmation from './components/ForgottenConfirmation';
import ResetForm from './components/ResetForm';
import ErrorForm from './components/ErrorForm';
import NotFoundPage from './components/404Page';

const PublicArea = () => (
    <div>
        {/* <!-- Background image that covers the entire screen, but excludes screen sizes smaller than tablet --> */}
        <div className="btp-signin-bg">
            {/* <!-- Wrapper around the logo, form, and other items on the page --> */}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-7 col-xl-7 btp-signin-form-bg mt-sm-3 mt-md-5">
                        {/* <!-- Logo --> */}
                        <div className="text-center mt-2 pt-2">
                            <img
                                src={BtPlusLogo}
                                alt="Boardtrac"
                                className="img-fluid btp-form-logo"
                            />
                        </div>
                        <Switch>
                            <Route exact path="/login" component={SignInForm} />

                            <Route exact path="/register" component={RegisterForm} />
                            <Route exact path="/forgotten" component={ForgottenForm} />
                            <Route exact path="/pin" component={PinForm} />
                            <Route exact path="/error" component={ErrorForm} />
                            <Route
                                exact
                                path="/forgottenconfirmation"
                                component={ForgottenConfirmation}
                            />
                            <Route exact path="/reset" component={ResetForm} />
                            {!window.offlineApiExtension && !window.require && (
                                <Route component={NotFoundPage} />
                            )}
                            <Redirect to="/login" />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default PublicArea;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/PublicArea.js